import { firm } from "@/config/firm.config";

export const Logo = ({ light = true, compact = false }) => (
  <span className="flex items-center gap-3">
    <img
      src="/assets/logo-mark.png"
      alt=""
      aria-hidden="true"
      width="40"
      height="40"
      className="h-10 w-10 shrink-0 object-contain"
    />
    <span className="leading-none">
      <span className={`block font-serif text-lg tracking-wide ${light ? "text-paper" : "text-navy-900"}`}>{firm.name}</span>
      {!compact && (
        <span className="mt-1 hidden font-mono text-[10px] uppercase tracking-[0.28em] text-gold sm:block">{firm.tagline}</span>
      )}
    </span>
  </span>
);
